import './AnimatedImageSlider.css';
import React from 'react';
import { canUseDOM, get } from '../../utils';
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import InfiniteCarousel from './components/InfiniteCarousel';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import RouterLink from '../atoms/RouterLink';
const AnimatedImageSlider = _ref => {
  let {
    fields,
    params
  } = _ref;
  const sitecoreContext = useSitecoreContext();
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const [isVdsite, setIsVdsite] = React.useState(true);
  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  if (!fields || !fields.data || !fields.data.item || fields.data.item.images.length < 14) {
    // for resolution 1920x1080 -> need to be at least 14 images (7 on each carousel (5 in center & 2 on the sides))
    // 1920\350 = 5.4 (5 center & 0.2 left, 0.2 right)
    console.info('AnimatedImageSlider component render skipped. No fields provided or provided less than 14 images');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [AnimatedImageSlider component is empty: please provide data source]");
    }
    return null;
  }
  const hasTitle = Boolean(get(fields, 'data.item.title.jss.value'));
  const title = get(fields, 'data.item.title.jss');
  const sliderLink = get(fields, 'data.item.sliderLink.jss.value.href');
  const initialImages = get(fields, 'data.item.images', []);
  const middleIndex = Math.ceil(initialImages.length / 2);
  const imagesLeft = initialImages.slice(0, middleIndex);
  const imagesRight = initialImages.slice(middleIndex);
  const moveRight = rtl ? "left" : "right";
  const moveLeft = rtl ? "right" : "left";
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement(ComponentsWrapper, null, hasTitle && /*#__PURE__*/React.createElement(Text, {
    tag: "h3",
    className: "h3 h__title",
    field: title
  })), /*#__PURE__*/React.createElement(RouterLink, {
    href: sliderLink,
    linktype: "external"
  }, /*#__PURE__*/React.createElement(InfiniteCarousel, {
    direction: moveLeft,
    images: imagesLeft,
    rtl: rtl
  }), /*#__PURE__*/React.createElement(InfiniteCarousel, {
    direction: moveRight,
    images: imagesRight,
    rtl: rtl
  })));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, children);
};
const commonStyles = "ch060e2";
const rtlStyles = "rik5qw9";
const ltrStyles = "l1cd6jm6";
export default AnimatedImageSlider;